import Vue from "vue";
import Vuex from "vuex";
import Auth from "./Auth";
import Subscription from "./Subscription";
import Organization from "./Organization";
import Template from "./Template";
import Department from "./Department";
import Dashboard from "./Dashboard";
import Maintenance from "./Maintenance";
import Lookup from "./Lookup";
import RequestLog from "./RequestLog";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  modules: {
    Auth,
    Subscription,
    Organization,
    Template,
    Department,
    Dashboard,
    Maintenance,
    Lookup,
    RequestLog,
  },
  getters: {},
  mutations: {},
});
